var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-pane fade in active", attrs: { id: "tab_benchmarks" } },
    [
      _c("div", { staticClass: "tab__header" }, [
        _vm._v("Hearing Aid Patient Cycle")
      ]),
      _vm._v(" "),
      _c("Comparisons"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "kpi-benchmarks-table" },
        [
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c("TableSubHead", {
            attrs: {
              title: "Pre-Purchase Metrics",
              anchor: "pre-purchase-metrics"
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.benchPrePurchaseMetrics, function(metric, index) {
            return [
              _c("TableRowHead", { attrs: { name: metric.name } }),
              _vm._v(" "),
              _c(_vm.getComponentName(metric.field, "monthly"), {
                tag: "component",
                attrs: { metric: metric }
              }),
              _vm._v(" "),
              _c(_vm.getComponentName(metric.field, "annually"), {
                tag: "component",
                attrs: { metric: metric }
              })
            ]
          }),
          _vm._v(" "),
          _c("TableSubHead", {
            attrs: { title: "Conversion Metrics", anchor: "conversion-metrics" }
          }),
          _vm._v(" "),
          _vm._l(_vm.benchConversionMetrics, function(metric, index) {
            return _c(_vm.getComponentName(metric.field), {
              key: "conversion-metrics-" + metric.field + "-" + index,
              tag: "component",
              attrs: { metric: metric }
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.benchConversionFittingMetrics, function(metric, index) {
            return [
              _c(_vm.getComponentName(metric.field, "monthly"), {
                tag: "component",
                attrs: { metric: metric, title: metric.name + " - Monthly" }
              }),
              _vm._v(" "),
              _c(_vm.getComponentName(metric.field, "annually"), {
                tag: "component",
                attrs: { metric: metric, title: metric.name + " - Annually" }
              })
            ]
          }),
          _vm._v(" "),
          _c("TableSubHead", {
            attrs: {
              title: "Productivity and Financial Metrics",
              anchor: "productivity-metrics"
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.benchFinancialMetrics, function(metric, index) {
            return [
              _c("TableRowHead", { attrs: { name: metric.name } }),
              _vm._v(" "),
              _c(_vm.getComponentName(metric.field, "monthly"), {
                tag: "component",
                attrs: { metric: metric }
              }),
              _vm._v(" "),
              _c(_vm.getComponentName(metric.field, "annually"), {
                tag: "component",
                attrs: { metric: metric }
              })
            ]
          }),
          _vm._v(" "),
          _c("TableSubHead", {
            attrs: { title: "KPIs", anchor: "kpi-metrics" }
          }),
          _vm._v(" "),
          _vm._l(_vm.benchKpiMetrics, function(metric, index) {
            return _c(_vm.getComponentName(metric.field), {
              key: "kpi-metrics-" + metric.field + "-" + index,
              tag: "component",
              attrs: { metric: metric }
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "kpi-benchmarks-cycle" }, [
      _c("div", { staticClass: "tab__sub-header" }, [
        _vm._v("Crucial Events Leading to Purchase in Practices")
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "kpi-benchmarks-cycle__image",
        attrs: { src: "/images/audiology_patient_cycle.svg" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel grid" }, [
      _c("div", { staticClass: "grid__col--12" }, [
        _c(
          "ul",
          {
            staticClass: "nav nav-tabs nav-flat-bottom",
            staticStyle: { "text-align": "center" }
          },
          [
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link btn btn-default btn-round btn-200",
                  attrs: { href: "#pre-purchase-metrics" }
                },
                [_vm._v("Pre-Purchase Metrics")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link btn btn-default btn-round btn-200",
                  attrs: { href: "#conversion-metrics" }
                },
                [_vm._v("Conversion Metrics")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link btn btn-default btn-round btn-200",
                  attrs: { href: "#productivity-metrics" }
                },
                [_vm._v("Productivity Metrics")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link btn btn-default btn-round btn-200",
                  attrs: { href: "#kpi-metrics" }
                },
                [_vm._v("KPIs")]
              )
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c(
        "th",
        {
          staticClass: "header--name kpi-benchmarks-table__endColGroup",
          attrs: { rowspan: "2" }
        },
        [_vm._v("Metric Name")]
      ),
      _vm._v(" "),
      _c(
        "th",
        { staticClass: "header--benchmark-low", attrs: { rowspan: "2" } },
        [_vm._v("LOW"), _c("br"), _vm._v("(Bottom 20%)")]
      ),
      _vm._v(" "),
      _c(
        "th",
        { staticClass: "header--benchmark-median", attrs: { rowspan: "2" } },
        [_vm._v("Median")]
      ),
      _vm._v(" "),
      _c(
        "th",
        {
          staticClass:
            "header--benchmark-high kpi-benchmarks-table__endColGroup",
          attrs: { rowspan: "2" }
        },
        [_vm._v("HIGH"), _c("br"), _vm._v("(Top 20%)")]
      ),
      _vm._v(" "),
      _c(
        "th",
        {
          staticClass:
            "header--your-practice kpi-benchmarks-table__halfHeader kpi-benchmarks-table__endColGroup",
          attrs: { colspan: "2" }
        },
        [_vm._v("Your Practice")]
      ),
      _vm._v(" "),
      _c(
        "th",
        {
          staticClass: "header--plus-minus kpi-benchmarks-table__endColGroup",
          attrs: { colspan: "2" }
        },
        [_vm._v("+/- Median")]
      ),
      _vm._v(" "),
      _c("th", { staticClass: "header--comments", attrs: { rowspan: "2" } }, [
        _vm._v("Comments")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { staticClass: "header--py kpi-benchmarks-table__halfHeader" }, [
        _vm._v("Prior YTD")
      ]),
      _vm._v(" "),
      _c(
        "th",
        {
          staticClass:
            "header--cy kpi-benchmarks-table__halfHeader kpi-benchmarks-table__endColGroup"
        },
        [_vm._v("Current YTD")]
      ),
      _vm._v(" "),
      _c(
        "th",
        {
          staticClass:
            "header--plus-minus-closest kpi-benchmarks-table__halfHeader"
        },
        [_vm._v("~")]
      ),
      _vm._v(" "),
      _c(
        "th",
        {
          staticClass:
            "header--plus-minus-diff kpi-benchmarks-table__halfHeader kpi-benchmarks-table__endColGroup"
        },
        [_vm._v("Diff")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }